import { render } from "./menu-sidebar.html?vue&type=template&id=10f9ab60&ts=true"
import script from "./menu-sidebar.ts?vue&type=script&lang=ts"
export * from "./menu-sidebar.ts?vue&type=script&lang=ts"

import "./menu-sidebar.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/antonio/work/zanzar/inventario-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__